<template>
  <modal
    :height="600"
    :width="400"
  >
    <div
      class="container"
      @click.stop
    >
      <div class="header">
        <custom-icon-button
          button-name="close-clients-modal"
          class="icon"
          icon-name="times"
          @closeClientsModalButton="$emit('close-payment-modal')"
        />
      </div>
      <payment-form class="h-75"/>
    </div>
  </modal>
</template>

<script>
import Modal from './Modal.vue';
import PaymentForm from '../form/PaymentForm.vue';
import CustomIconButton from '../common/CustomIconButton.vue';

export default {
  name: 'payment-modal',

  components: {
    CustomIconButton,
    Modal,
    PaymentForm,
  },

  emits: ['closeNavigationModal', 'newDate'],

  props: {
    date: Object,
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/colors.scss';

.accept-button {
  background-color: $blue;
  border-radius: 5px;
  border: 1px solid $blue;
  color: $white;
  height: 30px;
  width: 100px;
}

.header {
  border-bottom: 1px solid $grey;
  display: flex;
  justify-content: right;
  margin-bottom: 10px;
  padding-bottom: 10px;
}

.icon {
  border: none;
  color: $grey;
  cursor: pointer;
  height: 20px;
  padding: 0;
  width: 20px;
}

</style>
